import React from 'react'
import {connect} from "react-redux"
import { makeStyles } from '@material-ui/core/styles'

import Container from "@material-ui/core/Container"
import Card from '@material-ui/core/Card'
import CardActionArea from '@material-ui/core/CardActionArea'
import CardContent from '@material-ui/core/CardContent'
import CardMedia from '@material-ui/core/CardMedia'
import CardActions from "@material-ui/core/CardActions"
import Typography from '@material-ui/core/Typography'

import { Link } from './Link'
import TermsOfUse from './canon/settings/TermsOfUse'

import { _t } from '../i18n/lang'

import canonLogo from '../img/canon.png'
import hpLogo from '../img/hp.png'
import lexmarkLogo from '../img/lexmark.png'
import epsonLogo from '../img/epson.png'
import jabraLogo from '../img/jabra.png'
import xeroxLogo from '../img/xerox.png'
import AjaxLoading from "./AjaxLoading"


const useStyles = makeStyles({
	cartWrap: {
		margin: '0 20px 20px 0',
		width: '200px'
	},
	media: {
		height: 140,
		backgroundSize: 'contain'
	},
	link: {
		fontSize: '18px',
		color: '#cb0101',
		padding: '0px 5px'
	},
	actionWrap: {
		padding: '5px 16px'
	},
	cartsWrap: {
		display: "flex",
		flexWrap: "wrap",
		marginBottom: '30px'
	}
});


const CanonCart = (props) => {
	const id = 'CANON';
	const { allowedVendors } = props

	if (!allowedVendors.includes(id)) {
		return <></>
	}

	const classes = useStyles();

	return (
		<Card className={classes.cartWrap}>
			<CardActionArea >
				<CardMedia
					className={classes.media}
					image={canonLogo}
					title="Canon logo"
				/>
				<CardContent>
					<Typography gutterBottom variant="h5" component="h2">
						{_t('DASHBOARD_CARD_CANON_HEADER')}
					</Typography>
					<Typography variant="body2" color="textSecondary" component="p">
						{_t('DASHBOARD_CARD_CANON_INFO')}
					</Typography>
				</CardContent>
			</CardActionArea>
			<CardActions className={classes.actionWrap}>
				<Link to='/canon/i-sensys-projects' as='button' size="small" color="primary" className={classes.link}>
					{_t('DASHBOARD_CARD_CANON_PROJECT_LINK')}
				</Link>
				<Link to='/canon/i-sensys-products' size="small" color="primary" className={classes.link}>
					{_t('DASHBOARD_CARD_CANON_PRODUCTS_LINK')}
				</Link>
			</CardActions>
		</Card>
	)
}


const HPCart = (props) => {
	const id = 'HP';
	const { allowedVendors } = props

	if (!allowedVendors.includes(id)) {
		return <></>
	}

	const classes = useStyles();

	return (
		<Card className={classes.cartWrap}>
			<CardActionArea >
				<CardMedia
					className={classes.media}
					image={hpLogo}
					title="HP logo"
				/>
				<CardContent>
					<Typography gutterBottom variant="h5" component="h2">
						{_t('DASHBOARD_CARD_HP_HEADER')}
					</Typography>
					<Typography variant="body2" color="textSecondary" component="p">
						{_t('DASHBOARD_CARD_CANON_INFO')}
					</Typography>
				</CardContent>
			</CardActionArea>
			<CardActions className={classes.actionWrap}>
				<Link to='/hp/projects' as='button' size="small" color="primary" className={classes.link}>
					{_t('DASHBOARD_CARD_CANON_PROJECT_LINK')}
				</Link>
				<Link to='/hp/products' size="small" color="primary" className={classes.link}>
					{_t('DASHBOARD_CARD_CANON_PRODUCTS_LINK')}
				</Link>
			</CardActions>
		</Card>
	)
}

const EpsonCart = ({ allowedVendors }) => {
	const id = 'EPSON';
	if (!allowedVendors.includes(id)) {
		return <></>
	}

	const classes = useStyles();

	return (
		<Card className={classes.cartWrap}>
			<CardActionArea >
				<CardMedia
					className={classes.media}
					image={epsonLogo}
					title="Epson"
				/>
				<CardContent>
					<Typography gutterBottom variant="h5" component="h2">
						{_t('DASHBOARD_CARD_EPSON_HEADER')}
					</Typography>
					<Typography variant="body2" color="textSecondary" component="p">
						{_t('DASHBOARD_CARD_CANON_INFO')}
					</Typography>
				</CardContent>
			</CardActionArea>
			<CardActions className={classes.actionWrap}>
				<Link to='/epson/projects' as='button' size="small" color="primary" className={classes.link}>
					{_t('DASHBOARD_CARD_CANON_PROJECT_LINK')}
				</Link>
				<Link to='/epson/products' size="small" color="primary" className={classes.link}>
					{_t('DASHBOARD_CARD_CANON_PRODUCTS_LINK')}
				</Link>
			</CardActions>
		</Card>
	)
}


const JabraCart = ({ allowedVendors }) => {
	const id = 'JABRA';
	if (!allowedVendors.includes(id)) {
		return <></>
	}

	const classes = useStyles();

	return (
		<Card className={classes.cartWrap}>
			<CardActionArea >
				<CardMedia
					className={classes.media}
					image={jabraLogo}
					title="Lexmark"
				/>
				<CardContent>
					<Typography gutterBottom variant="h5" component="h2">
						{_t('DASHBOARD_CARD_JABRA_HEADER', {pl: 'Jabra'})}
					</Typography>
					<Typography variant="body2" color="textSecondary" component="p">
						{_t('DASHBOARD_CARD_CANON_INFO')}
					</Typography>
				</CardContent>
			</CardActionArea>
			<CardActions className={classes.actionWrap}>
				<Link to='/jabra/projects' as='button' size="small" color="primary" className={classes.link}>
					{_t('DASHBOARD_CARD_CANON_PROJECT_LINK')}
				</Link>
				<Link to='/jabra/products' size="small" color="primary" className={classes.link}>
					{_t('DASHBOARD_CARD_CANON_PRODUCTS_LINK')}
				</Link>
			</CardActions>
		</Card>
	)
}

const LexmarkCart = ({ allowedVendors }) => {
	const id = 'LEXMARK';
	if (!allowedVendors.includes(id)) {
		return <></>
	}

	const classes = useStyles();

	return (
		<Card className={classes.cartWrap}>
			<CardActionArea >
				<CardMedia
					className={classes.media}
					image={lexmarkLogo}
					title="Lexmark"
				/>
				<CardContent>
					<Typography gutterBottom variant="h5" component="h2">
						{_t('DASHBOARD_CARD_LEXMARK_HEADER')}
					</Typography>
					<Typography variant="body2" color="textSecondary" component="p">
						{_t('DASHBOARD_CARD_CANON_INFO')}
					</Typography>
				</CardContent>
			</CardActionArea>
			<CardActions className={classes.actionWrap}>
				<Link to='/lexmark/projects' as='button' size="small" color="primary" className={classes.link}>
					{_t('DASHBOARD_CARD_CANON_PROJECT_LINK')}
				</Link>
				<Link to='/lexmark/products' size="small" color="primary" className={classes.link}>
					{_t('DASHBOARD_CARD_CANON_PRODUCTS_LINK')}
				</Link>
			</CardActions>
		</Card>
	)
}

const XeroxCart = ({ allowedVendors }) => {
	const id = 'XEROX';
	if (!allowedVendors.includes(id)) {
		return <></>
	}

	const classes = useStyles();

	return (
		<Card className={classes.cartWrap}>
			<CardActionArea >
				<CardMedia
					className={classes.media}
					image={xeroxLogo}
					title="xerox"
				/>
				<CardContent>
					<Typography gutterBottom variant="h5" component="h2">
						{_t('DASHBOARD_CARD_XEROX_HEADER')}
					</Typography>
					<Typography variant="body2" color="textSecondary" component="p">
						{_t('DASHBOARD_CARD_CANON_INFO')}
					</Typography>
				</CardContent>
			</CardActionArea>
			<CardActions className={classes.actionWrap}>
				<Link to='/xerox/projects' as='button' size="small" color="primary" className={classes.link}>
					{_t('DASHBOARD_CARD_CANON_PROJECT_LINK')}
				</Link>
				<Link to='/xerox/products' size="small" color="primary" className={classes.link}>
					{_t('DASHBOARD_CARD_CANON_PRODUCTS_LINK')}
				</Link>
			</CardActions>
		</Card>
	)
}

const HomePage = (props) => {
	const { privileges } = props.user
	const classes = useStyles();
	return (
		<Container>
			<TermsOfUse />
			{!privileges
				? (
					<AjaxLoading />
				) : (
					<>
						<div className={classes.cartsWrap}>
							<CanonCart allowedVendors={privileges.allowedVendors} />
							<HPCart allowedVendors={privileges.allowedVendors} />
							<EpsonCart allowedVendors={privileges.allowedVendors} />
							<LexmarkCart allowedVendors={privileges.allowedVendors} />
							<JabraCart allowedVendors={privileges.allowedVendors} />
							<XeroxCart allowedVendors={privileges.allowedVendors} />
						</div>
					</>
				)
			}
		</Container>
	)
}
const mapStateToProps = (state) => {
	return {
		user: state.user,
	};
};

export default connect(mapStateToProps)(HomePage);
